import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export const createSidebarItems = () => {
  const sections = document.querySelectorAll('.data-section');
  const sidebar = document.querySelector('.sidebar');

  const ul = document.createElement('ul');
  ul.classList.add('invisible-scrollbar');

  const styleList = ['size-30', 'size-6', 'size-30', 'size-15', 'size-13', 'size-19', 'size-17', 'size-12', 'size-12', 'size-20', 'size-23', 'size-26', 'size-30', 'size-26', 'size-7', 'size-16', 'size-12', 'size-19', 'size-12', 'size-12'];

  sections.forEach((section, index) => {
    if (!section.id) return;

    const li = document.createElement('li');
    const a = document.createElement('a');

    a.href = `#${section.id}`;
    a.setAttribute('aria-label', 'Scroll to section');
    a.classList.add('sidebar__link');
    a.classList.add(styleList[index % styleList.length]);

    if(index == 0) {
      a.classList.add('active');
    }

    li.appendChild(a);
    ul.appendChild(li);

    a.addEventListener('click', (e) => {
      e.preventDefault();
      const sectionToScroll = document.querySelector(`#${section.id}`);
      const header = document.querySelector('.header');
      const headerHeight = header.offsetHeight;
      const offsetPosition = sectionToScroll.offsetTop - headerHeight;

      sectionToScroll.scrollIntoView({ top: offsetPosition, behavior: 'smooth' });
    });
  });

  sidebar.appendChild(ul);

  const menuLinks = document.querySelectorAll('.sidebar__link');
  const currentEl = document.querySelector('.current');
  const totalEl = document.querySelector('.total');

  totalEl.textContent = sections.length;

  sections.forEach((section, index) => {
    ScrollTrigger.create({
      trigger: section,
      start: index === 0 || index === 1 || index === 2 ? 'top top+=200' : 'top bottom-=500',
      end: index === 0 || index === 1 || index === 2 ? 'bottom top+=200' : 'bottom bottom-=500',

      onEnter: () => setActive(section),
      onEnterBack: () => setActive(section),
    });
  });

  function setActive(section) {
    const id = section.id;
    const index = [...sections].findIndex(s => s.id === id);

    menuLinks.forEach((link) => {
      link.classList.toggle( 'active', link.getAttribute('href') === `#${id}`);
    });

    currentEl.textContent = index + 1;
  }
}
